/**
 * React Calendar Component v0.1.0
 *
 * Copyright 2016, Dimitar Ivanov
 *
 * Dual licensed under the MIT and GPL licenses:
 *   http://www.opensource.org/licenses/mit-license.php
 *   http://www.gnu.org/licenses/gpl.html
 */
import React, {Component} from 'react';
import './calendar.css';

class Calendar extends Component {
  constructor(props) {
    super(props);
    var date = new Date();
    this.state = {
      year: date.getFullYear(),
      month: date.getMonth(),
      selectedYear: date.getFullYear(),
      selectedMonth: date.getMonth(),
      selectedDate: date.getDate(),
      selectedDt: new Date(date.getFullYear(), date.getMonth(), date.getDate()),
      startDay: 1,
      weekNumbers: false,
      minDate: this.props.minDate ? this.props.minDate : null,
      maxDate: this.props.maxDate ? this.props.maxDate : null,
      disablePast: this.props.disablePast ? this.props.disablePast : false,
      enabledDatesArray: this.props.enabledDatesArray || [],
      dayNames: [
        '星期日',
        '星期一',
        '星期二',
        '星期三',
        '星期四',
        '星期五',
        '星期六',
      ],
      mobileDayNames: ['日', '一', '二', '三', '四', '五', '六'],
      monthNames: [
        '一月',
        '二月',
        '三月',
        '四月',
        '五月',
        '六月',
        '七月',
        '八月',
        '九月',
        '十月',
        '十一月',
        '十二月',
      ],
      monthNamesFull: [
        '一月',
        '二月',
        '三月',
        '四月',
        '五月',
        '六月',
        '七月',
        '八月',
        '九月',
        '十月',
        '十一月',
        '十二月',
      ],
      firstOfMonth: null,
      daysInMonth: null,
    };
  }

  componentWillMount() {
    // this.setState(this.calc.call(null, this.state.year, this.state.month));

    let state = {};
    state.year = this.props.year !== null ? this.props.year : this.state.year;
    state.month =
      this.props.month !== null ? this.props.month : this.state.month;
    Object.assign(state, this.calc.call(null, state.year, state.month));
    this.setState(state);
  }

  componentDidMount() {}

  componentDidUpdate(prevProps, prevState) {
    if (this.props.onSelect && prevState.selectedDt !== this.state.selectedDt) {
      // this.props.onSelect.call(this.getDOMNode(), this.state);
      this.props.onSelect(this.state.selectedDt);
    }
  }

  render() {
    let {
      defaultValue = new Date(),
      dateChildrenComps = [],
      defaultDateChildrenComp = null,
      futureDateChildrenComp = null,
    } = this.props;
    // dateChildrenComps[]: {date: Date(), comp: <div>七吋</div>}

    return (
      <div className="r-calendar">
        <div className="r-inner">
          <Header
            monthNames={this.state.monthNamesFull}
            month={this.state.month}
            year={this.state.year}
            onPrev={this.getPrev}
            onNext={this.getNext}
          />
          <WeekDays
            dayNames={this.state.dayNames}
            mobileDayNames={this.state.mobileDayNames}
            startDay={this.state.startDay}
            weekNumbers={this.state.weekNumbers}
          />
          <MonthDates
            dayNames={this.state.dayNames}
            mobileDayNames={this.state.mobileDayNames}
            month={this.state.month}
            year={this.state.year}
            daysInMonth={this.state.daysInMonth}
            firstOfMonth={this.state.firstOfMonth}
            startDay={this.state.startDay}
            onSelect={this.selectDate}
            weekNumbers={this.state.weekNumbers}
            disablePast={this.state.disablePast}
            minDate={this.state.minDate}
            maxDate={this.state.maxDate}
            dateChildrenComps={dateChildrenComps}
            defaultDateChildrenComp={defaultDateChildrenComp}
            futureDateChildrenComp={futureDateChildrenComp}
            enabledDatesArray={this.state.enabledDatesArray}
            defaultValue={defaultValue}
            selectedEle={this.state.selectedElement}
          />
        </div>
      </div>
    );
  }

  calc = (year, month) => {
    if (this.state.selectedElement) {
      if (
        this.state.selectedMonth !== month ||
        this.state.selectedYear !== year
      ) {
        this.state.selectedElement.classList.remove('r-selected');
      } else {
        this.state.selectedElement.classList.add('r-selected');
      }
    }
    return {
      firstOfMonth: new Date(year, month, 1),
      daysInMonth: new Date(year, month + 1, 0).getDate(),
    };
  };

  getPrev = () => {
    var state = {};
    if (this.state.month > 0) {
      state.month = this.state.month - 1;
      state.year = this.state.year;
    } else {
      state.month = 11;
      state.year = this.state.year - 1;
    }
    Object.assign(state, this.calc.call(null, state.year, state.month));
    this.setState(state);
  };

  getNext = () => {
    var state = {};
    if (this.state.month < 11) {
      state.month = this.state.month + 1;
      state.year = this.state.year;
    } else {
      state.month = 0;
      state.year = this.state.year + 1;
    }
    Object.assign(state, this.calc.call(null, state.year, state.month));
    this.setState(state);
  };

  selectDate = (year, month, date, element) => {
    if (this.state.selectedElement) {
      this.state.selectedElement.classList.remove('r-selected');
    }
    element.target.classList.add('r-selected');
    this.setState({
      selectedYear: year,
      selectedMonth: month,
      selectedDate: date,
      selectedDt: new Date(year, month, date),
      selectedElement: element.target,
    });
  };
}

class Header extends Component {
  render() {
    return (
      <div className="r-row r-head">
        <div
          className="r-cell r-prev"
          onClick={this.props.onPrev.bind(this)}
          role="button"
          tabIndex="0"
        />
        <div className="r-cell r-title">
          {this.props.year}-{this.props.monthNames[this.props.month]}
        </div>
        <div
          className="r-cell r-next"
          onClick={this.props.onNext.bind(this)}
          role="button"
          tabIndex="0"
        />
      </div>
    );
  }
}
class WeekDays extends Component {
  render() {
    var that = this,
      haystack = Array.apply(null, {length: 7}).map(Number.call, Number);
    return (
      <div className="r-row r-weekdays">
        {(() => {
          if (that.props.weekNumbers) {
            return <div className="r-cell r-weeknum">wn</div>;
          }
        })()}
        {haystack.map(function (item, i) {
          return (
            <div key={'' + item + i} className="r-cell">
              <span className="desktop">
                {that.props.dayNames[(that.props.startDay + i) % 7]}
              </span>
              <span className="mobile">
                {that.props.mobileDayNames[(that.props.startDay + i) % 7]}
              </span>
            </div>
          );
        })}
      </div>
    );
  }
}

class MonthDates extends Component {
  constructor(props) {
    super(props);
    this.today = new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      new Date().getDate(),
    );
  }

  render() {
    let {
      defaultValue,
      year,
      month,
      selectedEle,
      dateChildrenComps,
      defaultDateChildrenComp,
      futureDateChildrenComp,
      dayNames,
      mobileDayNames,
    } = this.props;
    var haystack,
      day,
      d,
      current,
      isDate,
      className,
      weekStack = Array.apply(null, {length: 7}).map(Number.call, Number),
      that = this,
      startDay = this.props.firstOfMonth.getDay(),
      first = this.props.firstOfMonth.getDay(),
      janOne = new Date(that.props.year, 0, 1),
      rows = 5;

    if (
      (startDay === 6 && this.props.daysInMonth === 31) ||
      (startDay === 0 && this.props.daysInMonth > 29)
    ) {
      rows = 6;
    }

    className = rows === 6 ? 'r-dates' : 'r-dates r-fix';
    haystack = Array.apply(null, {length: rows}).map(Number.call, Number);
    day = this.props.startDay + 1 - first;
    while (day > 1) {
      day -= 7;
    }
    day -= 1;
    return (
      <div className={className}>
        {haystack.map(function (item, i) {
          d = day + i * 7;
          return (
            <div key={i} className="r-row">
              {(() => {
                if (that.props.weekNumbers) {
                  var wn = Math.ceil(
                    ((new Date(that.props.year, that.props.month, d) - janOne) /
                      86400000 +
                      janOne.getDay() +
                      1) /
                      7,
                  );
                  return <div className="r-cell r-weeknum">{wn}</div>;
                }
              })()}
              {weekStack.map(function (item, i) {
                d += 1;
                isDate = d > 0 && d <= that.props.daysInMonth;

                if (isDate) {
                  current = new Date(that.props.year, that.props.month, d);
                  className =
                    current !== that.today
                      ? 'r-cell r-date'
                      : 'r-cell r-date r-today';
                  if (that.props.disablePast && current < that.today) {
                    className += ' r-past';
                  } else if (
                    (that.props.minDate !== null &&
                      current < that.props.minDate) ||
                    (that.props.maxDate !== null &&
                      current > that.props.maxDate)
                  ) {
                    className += ' r-past';
                    if (
                      that.props.maxDate !== null &&
                      current > that.props.maxDate
                    ) {
                      className += ' rev-future';
                    } else {
                      className += ' rev-past';
                    }
                  } else if (that.props.enabledDatesArray.length > 0) {
                    let enabledDates = that.props.enabledDatesArray.map(
                      (enabledDate) => {
                        return new Date(
                          enabledDate.split('-')[0],
                          enabledDate.split('-')[1] - 1,
                          enabledDate.split('-')[2],
                        );
                      },
                    );
                    if (
                      enabledDates.every(
                        (date) => date.getTime() !== current.getTime(),
                      )
                    ) {
                      className += ' r-past';
                    }
                  }

                  //set defaultValue css
                  if (
                    defaultValue &&
                    year === defaultValue.getFullYear() &&
                    month === defaultValue.getMonth() &&
                    d === defaultValue.getDate() &&
                    !selectedEle
                  ) {
                    className += ' r-selected';
                  }

                  // get extra children comp
                  let foundChildrenComp = dateChildrenComps.find((item) => {
                    const _year = item.date.getFullYear();
                    const _month = item.date.getMonth();
                    const _date = item.date.getDate();
                    return (
                      year === _year &&
                      month === _month &&
                      d === _date &&
                      item.comp
                    );
                  });

                  if (!foundChildrenComp) {
                    className += ' rev-disabled';
                  }

                  if (/rev-future/.test(className)) {
                    return (
                      <div
                        key={d}
                        className={className}
                        style={{border: '2px solid #ffffff'}}
                        role="button"
                        tabIndex="0"
                        onClick={that.props.onSelect.bind(
                          that,
                          that.props.year,
                          that.props.month,
                          d,
                        )}>
                        <div
                          style={{
                            width: '100%',
                            backgroundColor: '#EFEFF4',
                            color: '#595757',
                            textAlign: 'center',
                            fontSize: 13,
                            lineHeight: '22px',
                          }}>
                          <span className="desktop">
                            {dayNames[(i + 1) % 7]}
                          </span>
                          <span className="mobile">
                            {mobileDayNames[(i + 1) % 7]}
                          </span>{' '}
                          {`${d}`.length < 2 ? `0${d}` : `${d}`}
                        </div>
                        <div style={{flex: 1}} className="desktop">
                          {futureDateChildrenComp}
                        </div>
                      </div>
                    );
                  }

                  if (/r-past/.test(className)) {
                    return (
                      <div
                        key={d}
                        className={className}
                        role="button"
                        tabIndex="0"
                        onClick={that.props.onSelect.bind(
                          that,
                          that.props.year,
                          that.props.month,
                          d,
                        )}>
                        <div
                          style={{
                            width: '100%',
                            backgroundColor: '#EFEFF4',
                            color: '#595757',
                            textAlign: 'center',
                            fontSize: 13,
                            lineHeight: '22px',
                          }}>
                          <span className="desktop">
                            {dayNames[(i + 1) % 7]}
                          </span>
                          <span className="mobile">
                            {mobileDayNames[(i + 1) % 7]}
                          </span>{' '}
                          {`${d}`.length < 2 ? `0${d}` : `${d}`}
                        </div>
                        <div style={{flex: 1}} className="desktop" />
                      </div>
                    );
                  }

                  return (
                    <div
                      key={d}
                      className={className}
                      role="button"
                      tabIndex="0"
                      onClick={that.props.onSelect.bind(
                        that,
                        that.props.year,
                        that.props.month,
                        d,
                      )}>
                      <div
                        style={{
                          width: '100%',
                          backgroundColor: foundChildrenComp
                            ? '#73A05C'
                            : '#995A5A',
                          color: '#ffffff',
                          textAlign: 'center',
                          fontSize: 13,
                          lineHeight: '22px',
                        }}>
                        <span className="desktop">{dayNames[(i + 1) % 7]}</span>
                        <span className="mobile">
                          {mobileDayNames[(i + 1) % 7]}
                        </span>{' '}
                        {`${d}`.length < 2 ? `0${d}` : `${d}`}
                      </div>
                      <div style={{flex: 1, width: '100%'}} className="desktop">
                        {foundChildrenComp
                          ? foundChildrenComp.comp
                          : defaultDateChildrenComp}
                      </div>
                    </div>
                  );
                }

                return <div key={d} className="r-cell" />;
              })}
            </div>
          );
        })}
      </div>
    );
  }
}

export default Calendar;
